import theme from '@/theme';
import styled from 'styled-components';

export const SideBarWrapper = styled.div`
    background-color: ${theme.color.white};
    display: flex;
    flex-direction: column;
    width: 100px;
    overflow: auto;
`;
